import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MCustomScrollbarDirective } from './m-custom-scrollbar.directive';

export const M_CUSTOM_SCROLLBAR_ASSETS = new InjectionToken<{ scripts: string[]; styles: string[]; }>('M_CUSTOM_SCROLLBAR_ASSETS');
export const mCustomScrollbarAssetsDefaultConfig = {
  scripts: ['/assets/mCustomScrollbar/jquery.mCustomScrollbar.concat.min.js'],
  styles: ['/assets/mCustomScrollbar/jquery.mCustomScrollbar.css']
};


/**
 * jQuery custom content scroller
 * [github](https://github.com/malihu/malihu-custom-scrollbar-plugin)
 * [官方網站](http://manos.malihu.gr/jquery-custom-content-scroller/)
 * 在引用套件的模組提供 M_CUSTOM_SCROLLBAR_ASSETS 這個依賴項目
 * ```typescript
 * {provide: M_CUSTOM_SCROLLBAR_ASSETS, useValue: {
 *   scripts: ['/assets/mCustomScrollbar/jquery.mCustomScrollbar.concat.min.js'],
 *   styles: ['/assets/mCustomScrollbar/jquery.mCustomScrollbar.css']
 * }}
 * ```
 */
@NgModule({
  declarations: [MCustomScrollbarDirective],
  imports: [
    CommonModule
  ],
  exports: [
    MCustomScrollbarDirective
  ]
})
export class MCustomScrollbarModule { }
